

import React, { useEffect } from 'react';
import { notification, Spin } from "antd";

import CompanyDetailSection from '../../shared/CompanyDetailSection';
import CustomerReviews from '../../shared/CustomerReviews';
import EnquireFormSection from '../../shared/EnquireFormSection';
import FeaturedCompaniesSection from '../../shared/FeaturedCompaniesSection';

const CommunityDetail = (props) => {
  const { followCompanyType, likeCompanyType, shareCompany, subscribe, getFeaturedIndustries, getPeopleNeededForHelp, enquireQuery, getCustomerReviews, getCommunity, match, history, user, communityDetails } = props;
  const { params } = match || {};
  const communityId = params && params.id ? Number(params.id) : null;
  const { customerReviews, numberOfPeople, featuredCommunities, community, loading } = communityDetails || {};
  const companyType = 'Community';
  useEffect(() => {
    if (communityId) {
      getCustomerReviews();
      getPeopleNeededForHelp();
      getFeaturedIndustries(companyType);
      getCommunity(communityId, user && user.id ? user.id : navigator.userAgent);
    } else {
      notification.error({
        message: 'GET CHARITY DETAILS',
        description: 'communityId is not valid'
      })
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <Spin spinning={loading}>
        <section className="school-details-banner gen-banner-2">
          <div className="container">
            <div className="banner-text">
              <h1 className="heading"> </h1>
              <p></p>
            </div>
          </div>
        </section>

        <CompanyDetailSection 
          data={community}
          numberOfPeople={numberOfPeople}
          companyType={companyType} 
          subscribe={subscribe} 
          user={user}
          history={history}
          shareCompany={shareCompany}
          getIndustryDetails={getCommunity}
          getCompanyTypeListings={getCommunity}
          followCompanyType={followCompanyType}
          likeCompanyType={likeCompanyType}
        />
        <CustomerReviews data={customerReviews} loading={loading}/>
        <FeaturedCompaniesSection 
          data={featuredCommunities}
          companyType={companyType}
        />
        <EnquireFormSection 
          enquireQuery={enquireQuery}
        />
      </Spin>
    </div>
  );
};

export default CommunityDetail;
